import { createSlice } from '@reduxjs/toolkit'
import { getItem } from 'helpers/localstorage.helpers'
import { LIVE_DATA, LIVE_WINS_RECORDS_LIMIT } from 'constants/index'

const storedLiveData = getItem(LIVE_DATA)

const initialState = {
  liveData: Array.isArray(storedLiveData) ? storedLiveData.slice(0, LIVE_WINS_RECORDS_LIMIT) : [],
  liveTransactionsData: { rows: [], count: 0 }
}

const {
  actions: { setLiveData },
  reducer
} = createSlice({
  name: 'casino',
  initialState,
  reducers: {
    setLiveData: (state, action) => {
      const incoming = action.payload?.data ? [action.payload] : action.payload
      const next = Array.isArray(incoming) ? incoming : [...state.liveData, incoming].filter(Boolean)
      return {
        ...state,
        liveData: next.slice(-LIVE_WINS_RECORDS_LIMIT)
      }
    }
  }
})

export { setLiveData }
export default reducer
